// @flow
import tiendaMiaCoverage from '../../../../assets/img/comparative/tiendamia/cobertura.png';
import tiendaMiaService from '../../../../assets/img/comparative/tiendamia/servicio.png';
import tiendaMiaMethod from '../../../../assets/img/comparative/tiendamia/metodo.png';
import tiendaMiaShipping from '../../../../assets/img/comparative/tiendamia/envio.png';
import tiendaMiaCoupons from '../../../../assets/img/comparative/tiendamia/cupones.png';
import tiendaMiaUser1 from '../../../../assets/img/comparative/tiendamia/alberto.jpg';
import tiendaMiaUser2 from '../../../../assets/img/comparative/tiendamia/ricardo.jpg';
import tiendaMiaUser3 from '../../../../assets/img/comparative/tiendamia/lagrase.jpg';

import aeropostSpeed from '../../../../assets/img/comparative/aeropost/rapidez.png';
import aeropostWarranty from '../../../../assets/img/comparative/aeropost/garantia.png';
import aeropostMethod from '../../../../assets/img/comparative/aeropost/metodo.png';
import aeropostCoupons from '../../../../assets/img/comparative/aeropost/cupones.png';
import aeropostService from '../../../../assets/img/comparative/aeropost/servicio.png';
import aeropostUser1 from '../../../../assets/img/comparative/aeropost/ana.jpg';
import aeropostUser2 from '../../../../assets/img/comparative/aeropost/brian.jpg';
import aeropostUser3 from '../../../../assets/img/comparative/aeropost/jacky.jpg';

import eShopexWarranty from '../../../../assets/img/comparative/eshopex/garantia.png';
import eShopexShipping from '../../../../assets/img/comparative/eshopex/envio.png';
import eShopexTracing from '../../../../assets/img/comparative/eshopex/seguimiento.png';
import eShopexCoupons from '../../../../assets/img/comparative/eshopex/cupones.png';
import eShopexService from '../../../../assets/img/comparative/eshopex/servicio.png';
import eShopexUser1 from '../../../../assets/img/comparative/eshopex/jose.jpg';
import eShopexUser2 from '../../../../assets/img/comparative/eshopex/jaime.jpg';
import eShopexUser3 from '../../../../assets/img/comparative/eshopex/paola.jpg';

export type Comparative = {
  rivalry: string;
  short: string;
  subtitle: string;
  subtitle2: string;
  features: Feature[];
  answers: Answer[];
  testimonies: Testimony[];
  meta: {
    title: { [key: string]: string } | string;
    description: { [key: string]: string } | string;
  };
};

export type Feature = {
  label: string;
  qempo: string | boolean;
  rivalry: string | boolean;
};

export type Answer = {
  title: string;
  content: string;
  image: string;
};

export type Testimony = {
  autor: string;
  image: string;
  location: string;
  testimony: string;
};

const comparativesIntl: { [key: string]: Comparative } = {
  guvery: {
    rivalry: 'Guvery',
    short: 'comparative.guvery.short',
    subtitle: 'comparative.guvery.subtitle',
    subtitle2: 'comparative.guvery.subtitle2',
    features: [
      {
        label: 'comparative.feature.deliveryTimes',
        qempo: 'comparative.feature.deliveryTimes.qempo',
        rivalry: 'comparative.feature.deliveryTimes.guvery',
      },
      {
        label: 'comparative.feature.priceAllIncluded',
        qempo: true,
        rivalry: 'comparative.feature.priceAllIncluded.rivalry',
      },
      {
        label: 'comparative.feature.shippingAllOverTheCountry',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.paymentByCreditCardDebitCardOrPaypal',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.guaranteeReturnChanges',
        qempo: 'comparative.feature.guaranteeReturnChanges.qempo',
        rivalry: false,
      },
      {
        label: 'comparative.feature.canIApplyForStoreCoupons',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.trackingOrder',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.customsSupport',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.importsWithTravelers',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.localCustomerService',
        qempo: true,
        rivalry: true,
      },
    ],
    answers: [
      {
        title: 'comparative.tiendaMia.answerOne.title',
        content: 'comparative.tiendaMia.answerOne.content',
        image: tiendaMiaCoverage,
      },
      {
        title: 'comparative.tiendaMia.answerTwo.title',
        content: 'comparative.tiendaMia.answerTwo.content',
        image: tiendaMiaService,
      },
      {
        title: 'comparative.tiendaMia.answerThree.title',
        content: 'comparative.tiendaMia.answerThree.content',
        image: tiendaMiaMethod,
      },
      {
        title: 'comparative.tiendaMia.answerFour.title',
        content: 'comparative.tiendaMia.answerFour.content',
        image: tiendaMiaShipping,
      },
      {
        title: 'comparative.tiendaMia.answerFive.title',
        content: 'comparative.tiendaMia.answerFive.content',
        image: tiendaMiaCoupons,
      },
    ],
    testimonies: [
      {
        autor: 'Luis Gallo',
        image: tiendaMiaUser1,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyOne',
      },
      {
        autor: 'John Corzo',
        image: tiendaMiaUser2,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyTwo',
      },
      {
        autor: 'Grace Santillan',
        image: tiendaMiaUser3,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyThree',
      },
    ],
    meta: {
      title: 'comparative.guvery.meta.title',
      description: 'comparative.guvery.meta.description',
    }
  },
  skyBox: {
    rivalry: 'Sky Box',
    short: 'comparative.skyBox.short',
    subtitle: 'comparative.skyBox.subtitle',
    subtitle2: 'comparative.skyBox.subtitle2',
    features: [
      {
        label: 'comparative.feature.deliveryTimes',
        qempo: 'comparative.feature.deliveryTimes.qempo',
        rivalry: 'comparative.feature.deliveryTimes.skyBox',
      },
      {
        label: 'comparative.feature.registration',
        qempo: 'comparative.feature.registration.qempo',
        rivalry: 'comparative.feature.registration.skyBox',
      },
      {
        label: 'comparative.feature.deliveryMethod',
        qempo: 'comparative.feature.deliveryMethod.qempo',
        rivalry: 'comparative.feature.deliveryMethod.rivalry',
      },
      {
        label: 'comparative.feature.perfumesSupplementsMakeaup',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.shippingAllOverTheCountry',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.guaranteeReturnChanges',
        qempo: 'comparative.feature.guaranteeReturnChanges.qempo',
        rivalry: false,
      },
      {
        label: 'comparative.feature.localPaymentsInBankOrCash',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.canIApplyForStoreCoupons',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.localCustomerService',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.trackingOrder',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.postalBox',
        qempo: false,
        rivalry: true,
      },
    ],
    answers: [
      {
        title: 'comparative.tiendaMia.answerOne.title',
        content: 'comparative.tiendaMia.answerOne.content',
        image: tiendaMiaCoverage,
      },
      {
        title: 'comparative.tiendaMia.answerTwo.title',
        content: 'comparative.tiendaMia.answerTwo.content',
        image: tiendaMiaService,
      },
      {
        title: 'comparative.tiendaMia.answerThree.title',
        content: 'comparative.tiendaMia.answerThree.content',
        image: tiendaMiaMethod,
      },
      {
        title: 'comparative.tiendaMia.answerFour.title',
        content: 'comparative.tiendaMia.answerFour.content',
        image: tiendaMiaShipping,
      },
      {
        title: 'comparative.tiendaMia.answerFive.title',
        content: 'comparative.tiendaMia.answerFive.content',
        image: tiendaMiaCoupons,
      },
    ],
    testimonies: [
      {
        autor: 'Luis Gallo',
        image: tiendaMiaUser1,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyOne',
      },
      {
        autor: 'John Corzo',
        image: tiendaMiaUser2,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyTwo',
      },
      {
        autor: 'Grace Santillan',
        image: tiendaMiaUser3,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyThree',
      },
    ],
    meta: {
      title: 'comparative.skyBox.meta.title',
      description: 'comparative.skyBox.meta.description',
    }
  },
  compraEnUsa: {
    rivalry: 'Compra en USA',
    short: 'comparative.compraEnUsa.short',
    subtitle: 'comparative.compraEnUsa.short',
    subtitle2: 'comparative.compraEnUsa.subtitle2',
    features: [
      {
        label: 'comparative.feature.deliveryTimes',
        qempo: 'comparative.feature.deliveryTimes.qempo',
        rivalry: 'comparative.feature.deliveryTimes.compraEnUsa',
      },
      {
        label: 'comparative.feature.priceAllIncluded',
        qempo: true,
        rivalry: 'comparative.feature.priceAllIncluded.rivalry',
      },
      {
        label: 'comparative.feature.deliveryMethod',
        qempo: 'comparative.feature.deliveryMethod.qempo',
        rivalry: 'comparative.feature.deliveryMethod.rivalry',
      },
      {
        label: 'comparative.feature.perfumesSupplementsMakeaup',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.shippingAllOverTheCountry',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.guaranteeReturnChanges',
        qempo: 'comparative.feature.guaranteeReturnChanges.qempo',
        rivalry: false,
      },
      {
        label: 'comparative.feature.localPaymentsInBankOrCash',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.canIApplyForStoreCoupons',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.localCustomerService',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.trackingOrder',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.postalBox',
        qempo: false,
        rivalry: true,
      },
    ],
    answers: [
      {
        title: 'comparative.tiendaMia.answerOne.title',
        content: 'comparative.tiendaMia.answerOne.content',
        image: tiendaMiaCoverage,
      },
      {
        title: 'comparative.tiendaMia.answerTwo.title',
        content: 'comparative.tiendaMia.answerTwo.content',
        image: tiendaMiaService,
      },
      {
        title: 'comparative.tiendaMia.answerThree.title',
        content: 'comparative.tiendaMia.answerThree.content',
        image: tiendaMiaMethod,
      },
      {
        title: 'comparative.tiendaMia.answerFour.title',
        content: 'comparative.tiendaMia.answerFour.content',
        image: tiendaMiaShipping,
      },
      {
        title: 'comparative.tiendaMia.answerFive.title',
        content: 'comparative.tiendaMia.answerFive.content',
        image: tiendaMiaCoupons,
      },
    ],
    testimonies: [
      {
        autor: 'Luis Gallo',
        image: tiendaMiaUser1,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyOne',
      },
      {
        autor: 'John Corzo',
        image: tiendaMiaUser2,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyTwo',
      },
      {
        autor: 'Grace Santillan',
        image: tiendaMiaUser3,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyThree',
      },
    ],
    meta: {
      title: 'comparative.compraEnUsa.meta.title',
      description: 'comparative.compraEnUsa.meta.description',
    }
  },
  compartoMiMaleta: {
    rivalry: 'Comparto Mi Maleta',
    short: 'comparative.compartoMiMaleta.short',
    subtitle: 'comparative.compartoMiMaleta.subtitle',
    subtitle2: 'comparative.compartoMiMaleta.subtitle2',
    features: [
      {
        label: 'comparative.feature.deliveryTimes',
        qempo: 'comparative.feature.deliveryTimes.qempo',
        rivalry: 'comparative.feature.deliveryTimes.CompartoMiMaleta',
      },
      {
        label: 'comparative.feature.priceAllIncluded',
        qempo: true,
        rivalry: 'comparative.feature.priceAllIncluded.rivalry',
      },
      {
        label: 'comparative.feature.shippingAllOverTheCountry',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.localPaymentsInBankOrCash',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.guaranteeReturnChanges',
        qempo: 'comparative.feature.guaranteeReturnChanges.qempo',
        rivalry: false,
      },
      {
        label: 'comparative.feature.canIApplyForStoreCoupons',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.trackingOrder',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.customsSupport',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.importsWithTravelers',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.localCustomerService',
        qempo: true,
        rivalry: true,
      },
    ],
    answers: [
      {
        title: 'comparative.tiendaMia.answerOne.title',
        content: 'comparative.tiendaMia.answerOne.content',
        image: tiendaMiaCoverage,
      },
      {
        title: 'comparative.tiendaMia.answerTwo.title',
        content: 'comparative.tiendaMia.answerTwo.content',
        image: tiendaMiaService,
      },
      {
        title: 'comparative.tiendaMia.answerThree.title',
        content: 'comparative.tiendaMia.answerThree.content',
        image: tiendaMiaMethod,
      },
      {
        title: 'comparative.tiendaMia.answerFour.title',
        content: 'comparative.tiendaMia.answerFour.content',
        image: tiendaMiaShipping,
      },
      {
        title: 'comparative.tiendaMia.answerFive.title',
        content: 'comparative.tiendaMia.answerFive.content',
        image: tiendaMiaCoupons,
      },
    ],
    testimonies: [
      {
        autor: 'Luis Gallo',
        image: tiendaMiaUser1,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyOne',
      },
      {
        autor: 'John Corzo',
        image: tiendaMiaUser2,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyTwo',
      },
      {
        autor: 'Grace Santillan',
        image: tiendaMiaUser3,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyThree',
      },
    ],
    meta: {
      title: 'comparative.compartoMiMaleta.meta.title',
      description: 'comparative.compartoMiMaleta.meta.description',
    }
  },
  grabr: {
    rivalry: 'Grabr',
    short: 'comparative.grabr.short',
    subtitle: 'comparative.grabr.subtitle',
    subtitle2: 'comparative.grabr.subtitle2',
    features: [
      {
        label: 'comparative.feature.guaranteeReturnChanges',
        qempo: 'comparative.feature.guaranteeReturnChanges.qempo',
        rivalry: false,
      },
      {
        label: 'comparative.feature.priceAllIncluded',
        qempo: true,
        rivalry: 'comparative.feature.priceAllIncluded.rivalry',
      },
      {
        label: 'comparative.feature.shippingAllOverTheCountry',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.paymentByCreditCardDebitCardOrPaypal',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.localCustomerService',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.customsSupport',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.canIApplyForStoreCoupons',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.localPaymentsInBankOrCash',
        qempo: true,
        rivalry: true,
      },
    ],
    answers: [
      {
        title: 'comparative.tiendaMia.answerOne.title',
        content: 'comparative.tiendaMia.answerOne.content',
        image: tiendaMiaCoverage,
      },
      {
        title: 'comparative.tiendaMia.answerTwo.title',
        content: 'comparative.tiendaMia.answerTwo.content',
        image: tiendaMiaService,
      },
      {
        title: 'comparative.tiendaMia.answerThree.title',
        content: 'comparative.tiendaMia.answerThree.content',
        image: tiendaMiaMethod,
      },
      {
        title: 'comparative.tiendaMia.answerFour.title',
        content: 'comparative.tiendaMia.answerFour.content',
        image: tiendaMiaShipping,
      },
      {
        title: 'comparative.tiendaMia.answerFive.title',
        content: 'comparative.tiendaMia.answerFive.content',
        image: tiendaMiaCoupons,
      },
    ],
    testimonies: [
      {
        autor: 'Luis Gallo',
        image: tiendaMiaUser1,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyOne',
      },
      {
        autor: 'John Corzo',
        image: tiendaMiaUser2,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyTwo',
      },
      {
        autor: 'Grace Santillan',
        image: tiendaMiaUser3,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyThree',
      },
    ],
    meta: {
      title: {
        US: 'comparative.grabr.meta.title.US',
        PE: 'comparative.grabr.meta.title.PE',
        CO: 'comparative.grabr.meta.title.CO',
      },
      description: {
        US: 'comparative.grabr.meta.description.US',
        PE: 'comparative.grabr.meta.description.PE',
        CO: 'comparative.grabr.meta.description.CO',
      },
    }
  },
  tiendaMia: {
    rivalry: 'TiendaMIA',
    short: 'comparative.tiendaMia.short',
    subtitle: 'comparative.tiendaMia.subtitle',
    subtitle2: 'comparative.tiendaMia.subtitle2',
    features: [
      {
        label: 'comparative.feature.storesWhereToBuy',
        qempo: 'comparative.feature.storesWhereToBuy.qempo',
        rivalry: 'comparative.feature.storesWhereToBuy.tiendaMia',
      },
      {
        label: 'comparative.feature.deliveryTimes',
        qempo: 'comparative.feature.deliveryTimes.qempo',
        rivalry: 'comparative.feature.deliveryTimes.tiendaMia',
      },
      {
        label: 'comparative.feature.guaranteeReturnChanges',
        qempo: 'comparative.feature.guaranteeReturnChanges.qempo',
        rivalry: 'comparative.feature.guaranteeReturnChanges.tiendamia',
      },
      {
        label: 'comparative.feature.deliveryMethod',
        qempo: 'comparative.feature.deliveryMethod.qempo',
        rivalry: 'comparative.feature.deliveryMethod.rivalry',
      },
      /*{
        label: 'comparative.feature.canICancelMyOrder',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.localCustomerService',
        qempo: true,
        rivalry: false,
      },*/
      {
        label: 'comparative.feature.priceAllIncluded',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.perfumesSupplementsMakeaup',
        qempo: true,
        rivalry: 'comparative.feature.perfumesSupplementsMakeaup.tiendamia',
      },
      {
        label: 'comparative.feature.canIApplyForStoreCoupons',
        qempo: true,
        rivalry: false,
      },
      /*{
        label: 'comparative.feature.shippingAllOverTheCountry',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.localPaymentsInBankOrCash',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.trackingOrder',
        qempo: true,
        rivalry: true,
      },*/
      {
        label: 'comparative.feature.freeCustoms',
        qempo: 'comparative.feature.freeCustoms.qempo',
        rivalry: 'comparative.feature.freeCustoms.tiendamia',
      },
      {
        label: 'comparative.feature.unlimitedImportations',
        qempo: 'comparative.feature.unlimitedImportations.qempo',
        rivalry: 'comparative.feature.unlimitedImportations.tiendamia',
      },
    ],
    answers: [
      {
        title: 'comparative.tiendaMia.answerOne.title',
        content: 'comparative.tiendaMia.answerOne.content',
        image: tiendaMiaCoverage,
      },
      {
        title: 'comparative.tiendaMia.answerTwo.title',
        content: 'comparative.tiendaMia.answerTwo.content',
        image: tiendaMiaService,
      },
      {
        title: 'comparative.tiendaMia.answerThree.title',
        content: 'comparative.tiendaMia.answerThree.content',
        image: tiendaMiaMethod,
      },
      {
        title: 'comparative.tiendaMia.answerFour.title',
        content: 'comparative.tiendaMia.answerFour.content',
        image: tiendaMiaShipping,
      },
      {
        title: 'comparative.tiendaMia.answerFive.title',
        content: 'comparative.tiendaMia.answerFive.content',
        image: tiendaMiaCoupons,
      },
    ],
    testimonies: [
      {
        autor: 'Luis Gallo',
        image: tiendaMiaUser1,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyOne',
      },
      {
        autor: 'John Corzo',
        image: tiendaMiaUser2,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyTwo',
      },
      /*{
        autor: 'Grace Santillan',
        image: tiendaMiaUser3,
        location: 'Lima, Perú',
        testimony: 'comparative.tiendaMia.testimonyThree',
      },*/
    ],
    meta: {
      title: {
        US: 'comparative.tiendaMia.meta.title.US',
        PE: 'comparative.tiendaMia.meta.title.PE',
        CO: 'comparative.tiendaMia.meta.title.CO',
      },
      description: {
        US: 'comparative.tiendaMia.meta.description.US',
        PE: 'comparative.tiendaMia.meta.description.PE',
        CO: 'comparative.tiendaMia.meta.description.CO',
      },
    }

  },
  aeropost: {
    rivalry: 'Aeropost',
    short: 'comparative.aeropost.short',
    subtitle: 'comparative.aeropost.subtitle',
    subtitle2: 'comparative.aeropost.subtitle2',
    features: [
      {
        label: 'comparative.feature.guaranteeReturnChanges',
        qempo: 'comparative.feature.guaranteeReturnChanges.qempo',
        rivalry: false,
      },
      {
        label: 'comparative.feature.deliveryTimes',
        qempo: 'comparative.feature.deliveryTimes.qempo',
        rivalry: 'comparative.feature.deliveryTimes.aeropost',
      },
      {
        label: 'comparative.feature.deliveryMethod',
        qempo: 'comparative.feature.deliveryMethod.qempo',
        rivalry: 'comparative.feature.deliveryMethod.rivalry',
      },
      {
        label: 'comparative.feature.paymentInCashOrBank',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.priceAllIncluded',
        qempo: true,
        rivalry: 'comparative.feature.priceAllIncluded.rivalry',
      },
      {
        label: 'comparative.feature.perfumesSupplementsMakeaup',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.localCustomerService',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.canIApplyForStoreCoupons',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.shippingAllOverTheCountry',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.trackingOrder',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.postalBox',
        qempo: false,
        rivalry: true,
      },
    ],
    answers: [
      {
        title: 'comparative.aeropost.answerOne.title',
        content: 'comparative.aeropost.answerOne.content',
        image: aeropostSpeed,
      },
      {
        title: 'comparative.aeropost.answerTwo.title',
        content: 'comparative.aeropost.answerTwo.content',
        image: aeropostWarranty,
      },
      {
        title: 'comparative.aeropost.answerThree.title',
        content: 'comparative.aeropost.answerThree.content',
        image: aeropostMethod,
      },
      {
        title: 'comparative.aeropost.answerFour.title',
        content: 'comparative.aeropost.answerFour.content',
        image: aeropostCoupons,
      },
      {
        title: 'comparative.aeropost.answerFive.title',
        content: 'comparative.aeropost.answerFive.content',
        image: aeropostService,
      },
    ],
    testimonies: [
      {
        autor: 'María Ludueña',
        image: aeropostUser1,
        location: 'Lima, Perú',
        testimony: 'comparative.aeropost.testimonyOne',
      },
      {
        autor: 'Brian Diaz',
        image: aeropostUser2,
        location: 'Lima, Perú',
        testimony: 'comparative.aeropost.testimonyTwo',
      },
      {
        autor: 'Edmundo Sotelo',
        image: aeropostUser3,
        location: 'Lima, Perú',
        testimony: 'comparative.aeropost.testimonyThree',
      },
    ],
    meta: {
      title: {
        US: 'comparative.aeropost.meta.title.US',
        PE: 'comparative.aeropost.meta.title.PE',
        CO: 'comparative.aeropost.meta.title.CO',
      },
      description: {
        US: 'comparative.aeropost.meta.description.US',
        PE: 'comparative.aeropost.meta.description.PE',
        CO: 'comparative.aeropost.meta.description.CO',
      },
    }
  },
  eShopex: {
    rivalry: 'eShopex',
    short: 'comparative.eShopex.short',
    subtitle: 'comparative.eShopex.subtitle',
    subtitle2: 'comparative.eShopex.subtitle2',
    features: [
      {
        label: 'comparative.feature.deliveryTimes',
        qempo: 'comparative.feature.deliveryTimes.qempo',
        rivalry: 'comparative.feature.deliveryTimes.eShopex',
      },
      {
        label: 'comparative.feature.priceAllIncluded',
        qempo: true,
        rivalry: 'comparative.feature.priceAllIncluded.rivalry',
      },
      {
        label: 'comparative.feature.deliveryMethod',
        qempo: 'comparative.feature.deliveryMethod.qempo',
        rivalry: 'comparative.feature.deliveryMethod.rivalry',
      },
      {
        label: 'comparative.feature.perfumesSupplementsMakeaup',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.shippingAllOverTheCountry',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.guaranteeReturnChanges',
        qempo: 'comparative.feature.guaranteeReturnChanges.qempo',
        rivalry: false,
      },
      {
        label: 'comparative.feature.localPaymentsInBankOrCash',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.canIApplyForStoreCoupons',
        qempo: true,
        rivalry: false,
      },
      {
        label: 'comparative.feature.trackingOrder',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.localCustomerService',
        qempo: true,
        rivalry: true,
      },
      {
        label: 'comparative.feature.postalBox',
        qempo: false,
        rivalry: true,
      },

    ],
    answers: [
      {
        title: 'comparative.eShopex.answerOne.title',
        content: 'comparative.eShopex.answerOne.content',
        image: eShopexWarranty,
      },
      {
        title: 'comparative.eShopex.answerTwo.title',
        content: 'comparative.eShopex.answerTwo.content',
        image: eShopexShipping,
      },
      {
        title: 'comparative.eShopex.answerThree.title',
        content: 'comparative.eShopex.answerThree.content',
        image: eShopexTracing,
      },
      {
        title: 'comparative.eShopex.answerFour.title',
        content: 'comparative.eShopex.answerFour.content',
        image: eShopexCoupons,
      },
      {
        title: 'comparative.eShopex.answerFive.title',
        content: 'comparative.eShopex.answerFive.content',
        image: eShopexService,
      },
    ],
    testimonies: [
      {
        autor: 'Gonzalo Arévalo',
        image: eShopexUser1,
        location: 'Lima, Perú',
        testimony: 'comparative.eShopex.testimonyOne',
      },
      {
        autor: '',
        image: eShopexUser2,
        location: 'Lima, Perú',
        testimony: 'comparative.eShopex.testimonyTwo',
      },
      {
        autor: 'Gabriela Dávalos',
        image: eShopexUser3,
        location: 'Lima, Perú',
        testimony: 'comparative.eShopex.testimonyThree',
      },
    ],
    meta: {
      title: {
        US: 'comparative.eShopex.meta.title.US',
        PE: 'comparative.eShopex.meta.title.PE',
        CO: 'comparative.eShopex.meta.title.CO',
      },
      description: {
        US: 'comparative.eShopex.meta.description.US',
        PE: 'comparative.eShopex.meta.description.PE',
        CO: 'comparative.eShopex.meta.description.CO',
      },
    }
  },
};

export function getComparative(store: string) {
  return comparativesIntl[store];
}



// WEBPACK FOOTER //
// ./src/modules/comparative/utils/comparative/index.js